import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {NumberParseService} from '../services/parser/number-parse.service';
import {Ratio} from '../model/ratio';
import {NgControl} from '@angular/forms';


@Directive({
    selector: '[appNumberFormat]',
    standalone: false
})
export class NumberFormatDirective {
  @Output() parsedValue = new EventEmitter<string>();
  @Output() value = new EventEmitter<number>();
  @Input() ratio: Ratio;
  @Input() maxNumber;
  @Input() decimalPlaces = 2;

  constructor(public numberParseService: NumberParseService, private readonly model: NgControl) {
  }

  prepareValues() {
    if (this.maxNumber == null) {
      if (this.ratio == Ratio.PERCENTAGE) {
        this.maxNumber = 100;
      } else if (this.ratio == Ratio.PER_THOUSAND) {
        this.maxNumber = 1000;
      } else {
        this.maxNumber = 1e12 - 0.01;
      }
    }

  }

  @HostListener('input', ['$event'])
  change(event) {
    this.prepareValues();
    const newValue = NumberParseService.parseLocaleNumber(event.target.value, this.ratio);
    if (!newValue) {
      this.parsedValue.emit(event.target.value);
      this.value.emit(null);
      return;
    }

    const target = event.target;
    const posStart = target.selectionStart;
    const posEnd = target.selectionEnd;
    const oldLength = target.value.toString().split('.').length - 1;
    const localNumber = this.numberParseService.convertToLocalNumber(newValue, this.decimalPlaces, this.maxNumber, this.ratio);

    this.model.control.setValue(NumberParseService.parseLocaleNumber(localNumber, this.ratio));
    this.model.valueAccessor.writeValue(localNumber);

    const newLength = target.value.toString().split('.').length - 1;
    let offset = newLength - oldLength;

    target.selectionStart = +posStart + (posStart + offset < 0 ? 0 : offset);
    target.selectionEnd = +posEnd + (posEnd + offset < 0 ? 0 : offset);

    this.value.emit(NumberParseService.parseLocaleNumber(event.target.value, this.ratio));
    this.parsedValue.emit(target.value);
  }

  @HostListener('convertNumber', ['$event'])
  convertNumber() {
    if (!(this.model.valid || this.model.disabled) || this.model.value == null || Number.isNaN(this.model.value)) {
      return;
    }
    const localNumber = this.numberParseService.convertToLocalNumber(this.model.value, this.decimalPlaces, this.maxNumber, this.ratio, true);
    this.model.valueAccessor.writeValue(localNumber);
  }
}
